import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Filter } from 'graphql-api/gql-api-interfaces';

@Component({
  selector: 'epc-filters-load-skeleton',
  templateUrl: './load-skeleton.component.html',
  styleUrls: ['./load-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FiltersLoadSkeletonComponent {
  @Input()
  public filters: Filter[] | {}[];

  public filterValuesSkeletonNumber = Array.from(new Array(10));

  private skeletonsIdxWithFilters = [0, 3, 4];

  public hasValues(index: number) {
    return this.skeletonsIdxWithFilters.some((v) => v === index);
  }
}
